<template>
	<v-footer color="#00807a">
		<span class="white--text">&copy; {{ year }}</span>
	</v-footer>
</template>

<script>
import moment from "moment";
export default {
	name: "Footer",
	data() {
		return {
			year: moment().format("YYYY"),
		};
	},
};
</script>

<style></style>
